const path = require('path'); 

const CORE_API_ENDPOINT = 'https://www.jogadamusical.com/core/';
//API DO CMS
const CMS_API_ENDOPINT = 'http://cms-imusica.int.imusicacorp.com/cms/jm/api/';
//API DO JOGADA MUSICAL
const EXTERNAL_API_ENDPOINT = 'http://api-jogadamusical.cluster.int.imusicacorp.com:8086/web/';

module.exports = {
	API: {
		local: CORE_API_ENDPOINT,
		endpoint: EXTERNAL_API_ENDPOINT,
		timeout: 60000,
		debug: {
			request: false,
			response: false
		},
		routes: {
			action: CORE_API_ENDPOINT + 'game',
			winner: CORE_API_ENDPOINT + "winner",
			headers: {
				requestHeaders: CORE_API_ENDPOINT + 'requestHeaders',
			},
			login: {
				requestSMS: CORE_API_ENDPOINT + 'user/requestSMS',
				validateCode: CORE_API_ENDPOINT + 'user/validateCode'
			},
			user: {
				getUser: CORE_API_ENDPOINT + 'user/getUser',
				subscribe: CORE_API_ENDPOINT + 'user/subscribe'
			},
			cmPhonogram:{
				phonogram: CORE_API_ENDPOINT + 'metadata/search/phonogram',
				artist: CORE_API_ENDPOINT + 'metadata/search/artist',
				album: CORE_API_ENDPOINT + 'metadata/search/album',
			},
			external: {
				action: EXTERNAL_API_ENDPOINT + 'action',
				winner: CMS_API_ENDOPINT + "winner",
				user: {
					getUser: EXTERNAL_API_ENDPOINT + 'user',
					subscribe: EXTERNAL_API_ENDPOINT + 'subscription/create'
				}
			}
		}
	},

	logFormat: 'dev',
	staticFiles: path.join(__dirname, '../../public'),
	sentry: {
		DSN: 'https://592eae33583e4d4d98e7a7fb3558cd58:a517ae1fd875454784d27a66ee7d127c@sentry.io/307111',
		environment: 'production'
	},

	// Redis Server configuration
	redisConfig: {
		host: 'ehvp-plataforma-redis-01.int.imusicacorp.com',
		port: 6379,
		db: 3,
		expirationTime: 3600,
		prefix: "im_jm:"
	},

	// RabbitMQ Server configuration
	rabbitConfig: {
		user: 'jogadamusical_op',
		pass: 'eb6vbAPTnb45',
		host: 'ehvp-plataforma-rabbit-01.int.imusicacorp.com',
		port: '5672',
		vHost: 'jogadamusical',
		queue: {
			sms : 'sms'
		}
	},

	// SMS configuration
	smsConfig: {
		shortCode: 7979,
		serviceId: "63",
		provider: "SGVAS",
		correlator: "1000",
		idPartnerBilling: 1,
		idPartnerContractHub: 440,
		messagePrefix: 'Seu codigo de validacao e ',
		smsCodeMaxAttempts: 3,
		validateSmsCodeMaxAttempts: 3,
	},

	// Solr configuration
	solrConfig: {
		host: 'solrslaves.cluster-cmaps.int.imusicacorp.com',
		port: 8082,
		path: '/search',
		solrVersion: '5.1',
		album     : 'album',
		artist    : 'artist',
		phonogram : 'phonogram'
	},
};



// WEBPACK FOOTER //
// ../config/production/core.js